import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "./vatStyles.css";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";
import { updateStoreVatUrl } from "../../../../api/endpoints";
import { setStore } from "../../../../slice/storeSlice";

const VATCollectionToggle = ({ isEnabled, defaultVATRate = 7.5, storeID, currency }) => {
  const [vatEnabled, setVatEnabled] = useState(isEnabled);
  const [vatRate, setVatRate] = useState(defaultVATRate);
  const [isEditing, setIsEditing] = useState(false);
  const [tempVatRate, setTempVatRate] = useState(defaultVATRate);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const saveUpdatedSettings = async (newState, vatRate) => {
    try {
      setIsLoading(true);
      const payload = {
        isVATenabled: newState,
        vatRate: vatRate,
      };

      const endpoint = updateStoreVatUrl + storeID;

      console.log(payload, endpoint, "Payload to update VAT settings");

      let response = await fetch(endpoint, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to update VAT settings");
      }

      let store = await response.json();
      dispatch(setStore(store));
      uiAlert("VAT settings updated successfully", "success");

      console.log(store, "Updated store VAT settings");
    } catch (error) {
      console.log("Error in onToggle:", error);
      uiAlert("An error occurred while toggling VAT collection. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggle = () => {
    const newState = !vatEnabled;
    setVatEnabled(newState);

    saveUpdatedSettings(newState, vatRate);
  };

  const handleEditClick = () => {
    setTempVatRate(vatRate);
    setIsEditing(true);
    setError("");
  };

  const handleVatRateChange = (e) => {
    const value = e.target.value;
    setTempVatRate(value);
    setError("");
  };

  const handleSaveVatRate = () => {
    const rate = parseFloat(tempVatRate);

    if (isNaN(rate)) {
      setError("Please enter a valid number");
      return;
    }

    if (rate < 0) {
      setError("VAT rate cannot be negative");
      return;
    }

    if (rate > 100) {
      setError("VAT rate cannot exceed 100%");
      return;
    }

    setVatRate(rate);
    setIsEditing(false);
    setError("");

    saveUpdatedSettings(vatEnabled, rate);
  };

  const handleCancelEdit = () => {
    setTempVatRate(vatRate);
    setIsEditing(false);
    setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSaveVatRate();
    } else if (e.key === "Escape") {
      handleCancelEdit();
    }
  };

  return (
    <div className='sl-vat-collection-container'>
      <div className='sl-vat-collection-card'>
        <div className='sl-vat-header'>
          <div className='sl-vat-icon-wrapper'>
            <svg className='sl-vat-icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <path d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z' />
            </svg>
          </div>
          <div className='sl-vat-header-content'>
            <h3 className='sl-vat-title'>VAT Collection</h3>
            <p className='sl-vat-subtitle'>Add Value Added Tax to all sales transactions</p>
          </div>
          <label className='sl-vat-toggle-switch'>
            <input disabled={isLoading} type='checkbox' checked={vatEnabled} onChange={handleToggle} className='sl-vat-toggle-input' />
            <span className='sl-vat-toggle-slider'></span>
          </label>
        </div>

        {vatEnabled && (
          <div className='sl-vat-details'>
            <div className='sl-vat-rate-section'>
              <div className='sl-vat-rate-info'>
                <div className='sl-vat-rate-label'>Current VAT Rate</div>
                {!isEditing ? (
                  <div className='sl-vat-rate-display'>
                    <span className='sl-vat-rate-value'>{vatRate}%</span>
                    <button className='sl-vat-edit-btn' onClick={handleEditClick}>
                      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                        <path d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' />
                      </svg>
                      Adjust
                    </button>
                  </div>
                ) : (
                  <div className='sl-vat-rate-editor'>
                    <div className='sl-vat-input-group'>
                      <input
                        type='number'
                        className={`sl-vat-rate-input ${error ? "sl-vat-input-error" : ""}`}
                        value={tempVatRate}
                        onChange={handleVatRateChange}
                        onKeyDown={handleKeyPress}
                        min='0'
                        max='100'
                        step='0.1'
                        autoFocus
                      />
                      <span className='sl-vat-input-suffix'>%</span>
                    </div>
                    {error && <span className='sl-vat-error-text'>{error}</span>}
                    <div className='sl-vat-editor-actions'>
                      <button className='sl-vat-action-btn sl-vat-cancel-btn' onClick={handleCancelEdit}>
                        Cancel
                      </button>
                      <button disabled={isLoading} className='sl-vat-action-btn sl-vat-save-btn' onClick={handleSaveVatRate}>
                        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                          <path d='M5 13l4 4L19 7' />
                        </svg>
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className='sl-vat-info-box'>
                <svg className='sl-vat-info-icon' viewBox='0 0 24 24' fill='currentColor'>
                  <path d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
                </svg>
                <p className='sl-vat-info-text'>
                  VAT of <strong>{vatRate}%</strong> will be automatically added to all sales. This appears as a separate line item on receipts and invoices.
                </p>
              </div>
            </div>

            <div className='sl-vat-example'>
              <div className='sl-vat-example-header'>
                <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <path d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z' />
                </svg>
                <span>Calculation Example</span>
              </div>
              <div className='sl-vat-example-content'>
                <div className='sl-vat-calc-row'>
                  <span className='sl-vat-calc-label'>Product Price:</span>
                  <span className='sl-vat-calc-value'>{currency} 1,000.00</span>
                </div>
                <div className='sl-vat-calc-row sl-vat-calc-highlight'>
                  <span className='sl-vat-calc-label'>VAT ({vatRate}%):</span>
                  <span className='sl-vat-calc-value'>
                    {currency} {((1000 * vatRate) / 100).toFixed(2)}
                  </span>
                </div>
                <div className='sl-vat-calc-divider'></div>
                <div className='sl-vat-calc-row sl-vat-calc-total'>
                  <span className='sl-vat-calc-label'>Total Amount:</span>
                  <span className='sl-vat-calc-value'>
                    {currency} {(1000 * (1 + vatRate / 100)).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VATCollectionToggle;
